// extracted by mini-css-extract-plugin
module.exports = {"button":"CheckCouponForm_button__fEqCs"};